import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import * as newProjectActions from '../Actions/newProjectActions';
import * as processingOrdersActions from '../Actions/processingOrdersActions';
import UploadOrderContainer from "../Containers/UploadOrderContainer.js";
import { orderService } from "../Services/OrderService.js";
import { Redirect } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import { withTranslation } from 'react-i18next';
//import ScrollToBottom from 'react-scroll-to-bottom';

//----------------------------------------------------------------
//	UploadProjectContainer
//----------------------------------------------------------------
//	El component agrupa varies caixes de documents per pujar (UploadOrderContainer)
//	Es responsable d'enviar totes aquestes tasques al BE
//----------------------------------------------------------------

class UploadProjectContainer extends Component {
	constructor(props) {
		super(props);
		
		this.uploading=0;
		this.state = {
			mlt:0,
			uploading: 0,
			quotation: props.location.pathname=="/quotationNew",
			needsScroll: false
		};
		//console.log("[UploadProjectContainer] Quotation: "+this.state.quotation);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.addUploadOrderContainer = this.addUploadOrderContainer.bind(this);
		this.handleChangeMlt = this.handleChangeMlt.bind(this);
		this.renderMLT = this.renderMLT.bind(this);
		this.removeUploadOrderContainer = this.removeUploadOrderContainer.bind(this);
	}
	componentDidMount() {
		//this.setState({
		//	uploading: 0,
		//	quotation: this.props.location.pathname=="/quotationNew"
		//});
		this.props.actions.resetProject();
	}
	
	handleSubmit(e) {
		//console.log("handleSubmit: ");

		this.uploading=1;
		this.setState({uploading: 1});
		orderService.uploadProject(this.state.quotation, this.props.orders, this.state.mlt)
			.then(response1 => { 	//console.log("response1.data: "+JSON.stringify(response1.data));
//									this.props.actions.addProcessing(response1.data.orders.map(order => order.id));
									this.props.actions.addProcessing();
									return orderService.runProjectWF(this.props.user.access_token, response1.data.id);})
			.then(response2 => { this.uploading=2; return this.props.actions.resetProject();})
//			.then(response3 => { this.uploading=2; return 1;})
			.catch(err => {this.uploading=-1; console.log(err); return this.props.actions.resetProject();});
	}
	
	addUploadOrderContainer(){
		this.setState({needsScroll: true});
		this.props.actions.addNewOrder();
	}
	
	removeUploadOrderContainer(id){
		this.setState({needsScroll: true});
//		console.log("removeUploadOrderContainer id: "+id);
		this.props.actions.removeOrder(id);
	}
	
	handleChangeMlt(e){
		this.setState({mlt: e.target.value});
	}
	
	renderMLT(){
		if ((typeof this.props.user.customer.multiLanguageTemplates === 'undefined')
			|| !Array.isArray(this.props.user.customer.multiLanguageTemplates)
			|| this.props.user.customer.multiLanguageTemplates.length==0
			|| this.props.orders.length>1){
			return "";
		}
		const lstMLT = [];
		lstMLT.push(<option value={0}></option>);
		this.props.user.customer.multiLanguageTemplates.sort((a, b) => a.name > b.name && 1 || -1 ).forEach(element => lstMLT.push(<option value={element.id}>{element.name}</option>))
		return (<Grid item  xs={12}>
					<FormControlLabel
						labelPlacement = "start"
						label={this.props.t('multilanguage')}
						control={
							<NativeSelect
								value={this.state.mlt}
								onChange={this.handleChangeMlt}
								>
								{lstMLT}
							</NativeSelect>
						}
					/>
				</Grid>)
	}
	
	componentDidUpdate() {
//		console.log("componentDidUpdate: " + document.documentElement.scrollHeight);
		
		if(this.state.needsScroll){
			this.setState({needsScroll: false});
			window.scroll(0, document.documentElement.scrollHeight);
		}
	}
  
	render() {
		//console.log('render [UploadProjectContainer]:'+this.props.orderIds);
		const { t } = this.props;
		let title=t('upload_docs');
		if(this.state.quotation){
			title=t('quotation');
		}
		if (this.uploading>0) {
			if (this.uploading>1) {
				if(this.state.quotation){
					return <Redirect to='/quotationList'/>;
				}else{
					return <Redirect to='/orderList'/>;
				}
			}else{
				return <div className="content_centered">{t('sending')}....&nbsp;&nbsp;<img src='/img/sending.gif' style={{width: "30px", height: "30px"}}/></div>;
			}
		}else if(this.uploading<0){
			return <Redirect to='/error'/>;
		}
		
		const newOrders = [];

		let sendDisabled=false;
		
		let i=0;
		//let mlt=0;
		//console.log("[UploadProjectContainer] Orders:");
		//console.log(this.props.orders);
		//console.log("----------------------------------");
		this.props.orders.forEach((order) => {
			if(order!=null){
				if(order.alerta || typeof(order.doc.name) == 'undefined' || order.task.length===0 || order.product.length===0){
					sendDisabled=true;
				}
				newOrders.push( <UploadOrderContainer enabled={order.enabled} newOrder={order} index={i} id={order.id} removeUploadOrderContainer={this.removeUploadOrderContainer}/> )
				i++;
			}
		});
		
		let btnDisabled = false;
		if(this.state.mlt>0){
			btnDisabled = true;
		}
		return (
			<div class="contentM">
			<form 
				action={this.props.action}
				method={this.props.method}
				onSubmit={this.handleSubmit}
			>
			<Grid container item direction="column" alignItems="flex-start" justify="center" spacing={0} xs={12}>
				<Grid container item direction="row" alignItems="center" justify="flex-startr" spacing={0} xs={12}>
					<h1 className="title">{title}</h1>
				</Grid>
				{this.renderMLT()}
				<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={0}>
					<Grid item xs={12}>
						{newOrders}
					</Grid>
				</Grid>
				<Grid container item direction="row" alignItems="flex-start" justify="center" spacing={0}>
					<Grid item xs={6}>
						<Button disabled={btnDisabled} style={{fontFamily: "'Lato', sans-serif", fontSize: "18px", padding: "15px", backgroundColor: "#dfdfdf", color: "#575757"}} onClick={this.addUploadOrderContainer}>
							{t('add_doc')}
						</Button>
					</Grid>
					<Grid item xs={6}>
						<Button disabled={sendDisabled} style={{fontFamily: "'Lato', sans-serif", fontSize: "18px", backgroundColor: "#dfdfdf"}} onClick={this.handleSubmit} color="primary">
							{t('send')}
						</Button>
					</Grid>
				</Grid>
			</Grid>
			</form>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {user: state.user, orders: state.newProject, sending: state.sending}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(Object.assign({}, newProjectActions, processingOrdersActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation() (UploadProjectContainer));